<template>
  <div>
    <Nuxt />

    <ClientOnly>
      <ModalComponent />
    </ClientOnly>

    <ClientOnly>
      <BaseModalGlobal />
    </ClientOnly>

    <ClientOnly>
      <IntercomLoading />
    </ClientOnly>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const BaseModalGlobal = () => import('@/components/Base/Modal/Global')
const IntercomLoading = () => import('@/components/IntercomLoading')
import i18nHead from '~/util/i18n/i18nHead'

export default {
  components: {
    BaseModalGlobal,
    IntercomLoading,
  },
  head() {
    return {
      title: this.get_seoPage.title,
      ...i18nHead(this.$nuxtI18nHead({ addSeoAttributes: true })),
      bodyAttrs: { class: 'theme-dark' },
    }
  },
  computed: {
    ...mapGetters('seo', ['get_seoPage']),
  },
}
</script>
